import { useTranslation } from 'next-i18next';
import { useAvailableWallets } from 'utils/store/availableWallets';
import { getPaymentMethod, getPaymentMethodId } from 'utils/store/paymentMethod';

import { usePaymentMethodsQuery } from '@/graphql/paymentMethods';

export function usePaymentMethodLabel() {
  const { t } = useTranslation('common');
  const { data } = usePaymentMethodsQuery();
  const { availableWallets } = useAvailableWallets();
  const paymentMethod = getPaymentMethod();
  const paymentMethodObj = data?.paymentMethods?.data?.find(pm => pm.id === getPaymentMethodId());
  const defaultLabel = t('giving.cta.add_payment_method');
  const displayLabel = paymentMethodObj?.displayLabel;

  if (paymentMethod === 'paymentRequest') {
    switch (true) {
      case availableWallets.applePay:
        return 'Apple Pay';
      case availableWallets.googlePay:
        return 'Google Pay';
      case availableWallets.link:
        return 'Link';
    }
  } else if (paymentMethod === 'paypal') {
    return 'PayPal';
  } else if (displayLabel) {
    return displayLabel;
  }

  return defaultLabel;
}
